module.exports = __webpack_public_path__ + "components/icon/static/sunset-18400097717845bf26773864461c2281.svg";